export default {
  autoReloadOffTooltip: 'Recarregamento automático desligado',
  forceRefreshTooltip: 'Atualizar dados dos componentes',
  autoReloadOnTooltip: 'Última atualização {date}',
};
